
import { Component } from 'vue-property-decorator';
import CaseDisplayerFilterable from '@/components/reports-v3/components/filterables/CaseDisplayerFilterable.vue';
import moment from 'moment';
import { COL, getTableName } from '@/worker/db/sqlHelpers';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import gdbx from '@/store/modules/gdbx';

@Component({
	components: {
		CaseDisplayerFilterable,
	},
})
export default class SalesOpenQuotationNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['sales'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['stockItems', 'agents', 'dateRange'];

	public caseAmount = 0;
	public totalAmount = 0;

	public get footer() {
		const date1 = moment(this.selectedDateRange[0]).format('DD MMM YYYY');
		const date2 = moment(this.selectedDateRange[1]).format('DD MMM YYYY');
		return date1 + ' - ' + date2;
	}

	public get expensiveHook() {
		const { selectedDateRange, selectedAgents, selectedStockItems } = this;
		return JSON.stringify([
			selectedDateRange,
			selectedAgents,
			selectedStockItems,
		]);
	}

	public async expensiveCalc() {
		const jobId = this.currentJobId;
		this.generateLoadingText(0.2, 0.4);

		const queryHead = await this._ensureTablesLoaded(['quotations'] as any[]);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.4, 0.9);

		const quotationsTable = getTableName('quotations');
		const dateFilter = `TRY_CAST(${COL.DOCDATE} AS BIGINT) BETWEEN ${this.selectedDateRange[0]} AND ${this.selectedDateRange[1]}`;
		const escapeStr = (s: string) => s.replace(/'/g, '\'\'');
		const allAgentLen = (gdbx.allAgents && gdbx.allAgents.length) || 0;
		const agentFilter = this.selectedAgents && this.selectedAgents.length > 0
			&& this.selectedAgents.length !== allAgentLen
			? ` AND ${COL.AGENT} IN (${this.selectedAgents.map((a: string) => `'${escapeStr(a)}'`).join(', ')})`
			: '';
		const allStockItemsLen = (gdbx.allStockItems && gdbx.allStockItems.length) || 0;
		const stockItemFilter = this.selectedStockItems && this.selectedStockItems.length > 0
			&& this.selectedStockItems.length !== allStockItemsLen
			? ` AND ${COL.ITEMCODE} IN (${this.selectedStockItems.map((s: string) => `'${escapeStr(s)}'`).join(', ')})`
			: '';

		const data = await queryHead.rawQuery(`
			SELECT COUNT(*) as caseCount,
				SUM(osAmt) as totalAmt
			FROM (
				SELECT "DOCNO",
					SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as docAmt,
					SUM(TRY_CAST("OUTSTANDINGAMOUNT" AS DOUBLE)) as osAmt
				FROM ${quotationsTable}
				WHERE ${dateFilter}${agentFilter}${stockItemFilter}
				GROUP BY "DOCNO"
				HAVING SUM(TRY_CAST("AMOUNT" AS DOUBLE)) = SUM(TRY_CAST("OUTSTANDINGAMOUNT" AS DOUBLE))
			) sub
		`);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.95);

		this.totalAmount = data[0] ? (Number(data[0].totalAmt) || 0) : 0;
		this.caseAmount = data[0] ? (Number(data[0].caseCount) || 0) : 0;

		this.saveHistory('caseAmount', 'totalAmount');
	}
}
